// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__PpE7E","largestCol":"styles_largestCol__1wc4E","smallestCol":"styles_smallestCol__1eUpA"};